<template>
<div id="main">
    <div class="cardtotalDespesas">
      <div class="justify-content-center mt-2 title-card-sales">
        Total de Gastos
      </div>
      <div>
        <div class="sales-value">
          <div class="stage-total">
            <template v-if="etapasMistas">
              <!-- Linha com as duas etapas (coordenador que tambem e tecnico, task 052): total de cada uma + o geral -->
              <div class="stage-label">AG. APROVAÇÃO TÉCNICO: {{ formatMoney(dataDetails.valorAgTecnico || 0) }}</div>
              <div class="stage-label">AG. APROVAÇÃO COORDENADOR: {{ formatMoney(dataDetails.valorAgCoordenador || 0) }}</div>
            </template>
            <div v-else class="stage-label">{{ statusFrase }}</div>
            <div class="stage-value">{{ formatMoney(totalFuncionarioDespesas || 0) }}</div>
          </div>
        </div>
        <div class="employee-value">
          <div class="employee-expenses">
            <div class="employee-title">Código </div>
            <div>{{ dataDetails.codigo }}</div>
          </div>
          <div class="employee-expenses">
            <div class="employee-title">Funcionário</div>
            <div :class="{ 'red-text': dataDetails.dataDemissao !== null }">{{ dataDetails.nomeColaborador }} </div>
          </div>
          <div class="employee-expenses">
            <div class="employee-title">Cargo  </div>
            <div>{{ dataDetails.cargo }} </div>
          </div>
          <div class="employee-expenses">
            <div class="employee-title">Obra </div>
            <div>{{ dataDetails.obra }} </div>
          </div>
          <div class="employee-expenses" v-if="!hasRole(roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL) && !hasRole(roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
            <div class="employee-title">Coordenador </div>
            <div>{{ dataDetails.coordenador }}</div>
          </div>
          <div class="employee-expenses" v-if="!hasRole(roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
            <div class="employee-title">Técnico </div>
            <div>{{ dataDetails.tecnico }}</div>
          </div>
        </div>
      </div>
    </div>
  <Forms ref="frmSearch"
           title="PESQUISA DE REEMBOLSO DIVERSOS"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClear"
           v-on:Search="$emit('onLoadFuncionario', dataFormSearch)"
          >
           <div>
              <div v-if="hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
                <label class="label-search">Situação:</label>
                <select v-model="dataFormSearch.situacao" class="form-control">
                  <option :value="null">Selecione um status</option>
                  <option v-for="data in dataStatusDespesa" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
              </div>
              <div>
                <label class="label-search">Categoria:</label>
                 <select v-model="dataFormSearch.categoria" class="form-control">
                  <option :value="null">Selecione uma categoria </option>
                  <option v-for="data in dataSubCategoria" :key="data.value" :value="data.value">{{data.text}}</option>
                </select>
              </div>
           </div>
      </Forms>
</div>
</template>

<script>
import paneldetails from './paneldetails'
export default paneldetails
</script>

<style scoped>
.red-text {
    color: red;
}
#main{
    height: 100%;
}
  .label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
  .title-card-sales {
  font-size: 24px;
  background: #008144;
  padding: 20px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  font-weight: bold;
}
.sales-value {
  padding: 0.75rem 1.25rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  background-color: white;
}
.stage-total {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
  padding: 0.4rem 0;
}
.stage-label {
  font-size: 13px;
  font-weight: 600;
  color: #5a6b62;
}
.stage-value {
  font-size: 18px;
  font-weight: bold;
  color: #025e33;
}
.employee-value {
  width: 100%;
  display: flex;
  padding: 1rem;
  font-size: 14px;
  background-color: white;
  flex-direction: column;
  font-family: 'Segoe UI';
  gap:1rem;
  border-radius: 0px 0px 8px 8px;
}

.employee-expenses{
  display: flex;
  flex-direction: column;
}

.employee-title{
  font-weight: bold;
}

.cardtotalDespesas{
    margin-bottom: 1rem;
}
/* .panel-total-despesasviagem-head{
    height: 40%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center ;
    color: white;
    font-weight: bold;
    font-size: 20px;
    border-radius: 10px 10px 0px 0px;
    background: green;

  }
.panel-total-despesasviagem-body{
    height: 60%;
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 20px;
    color: black;
    align-items: center;
  }
.panel-total-despesasviagem{
  width: 100%;
    background: white;
    height: 10%;
    border-radius:10px;
    margin-bottom: 5%;
  }
  */
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/paneldetails/paneldetails.vue